<template>
  <div v-if="entry" class="patient-field-discrepancy">
    <v-chip
      size="small"
      variant="tonal"
      label
      :color="entry.status === 'available' ? 'info' : 'warning'"
      prepend-icon="mdi-alert-circle-outline">
      Roster has: {{ entry.patientValue }}
    </v-chip>
    <v-btn
      v-if="entry.applicable"
      size="small"
      variant="tonal"
      color="info"
      prepend-icon="mdi-check"
      :loading="loading"
      @click="emit('apply', field)">
      Apply from roster
    </v-btn>
    <v-alert v-if="error" density="compact" variant="tonal" color="error" icon="mdi-alert-outline" role="alert">
      {{ error }}
    </v-alert>
  </div>
</template>

<script setup>
defineProps({
  field: { type: String, required: true },
  entry: { type: Object, default: null },
  loading: { type: Boolean, default: false },
  error: { type: String, default: null },
});

const emit = defineEmits(["apply"]);
</script>

<style scoped>
/* Positive top margin (not the field's negative-margin convention used elsewhere) so this never
   stacks on top of the input's own error-messages slot when both are shown at once. */
.patient-field-discrepancy {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
  margin-bottom: 8px;
}
</style>
